<script>
//See if we can factor this out and use ValueStorage instead.
export default {
    name: "signup",
    props: {
        id: {
            type: Number,
            required: false
        },
        membershipCategory: {
            type: Object,
            required: false,
            default: () => ({})
        },
        entity: {
            type: Object,
            required: true,
            default: () => {
            }
        },
        admin: {
            type: Boolean,
            default: false
        },
        existingMemberSignup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            membershipCategoryId: this.id ? this.id : '',
            existingMember: this.existing,
            member: this.entity,
            showEndDate: true,
        }
    },
    computed: {
        //If the member has previous been rejected.  Do no allow them to specify they are an existing member
        showExistingMemberCheckbox() {
            if (!this.existingMemberSignup || this.admin) {
                return false;
            }
            return this.member.member_approval_status != "rejected";
        },
        showPaymentOption() {
            if (!this.membershipCategoryId) {
                return false;
            }
            /*                if(this.admin){
                                return false;
                            }*/
            //If they cannot select exisitng member.  Then always enforce they select choose their payment option
            if (!this.showExistingMemberCheckbox) {
                return true;
            }
            //If they are not an exisitng member, show the box
            return !this.member.existing_member;
        },
        showOrders() {
            return this.member.payment_type == 'card';
        }
    },
    watch: {
        membershipCategoryId: function (val) {
            if (!val) {
                return;
            }
            var currentUrl = window.location.href;
            window.location.href = this.updateQueryStringParameter(currentUrl, 'membership_category_id', val);
        }
    },
    methods: {
        updateQueryStringParameter(uri, key, value) {
            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            if (uri.match(re)) {
                return uri.replace(re, '$1' + key + "=" + value + '$2');
            } else {
                return uri + separator + key + "=" + value;
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Signup.vue